import { connect } from 'react-redux'
import { compose } from 'redux'
import { highlightsUpdateItem } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { PROGRAM_HIGHLIGHTS, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CINEMAS, FEATURES, CLI_CINEMA_CLIENT_ID } from '../../../constants/state'
import EditHighlight from '../present/EditHighlight'
import getMovieSortedByTitle from '../../../functions/getMoviesSortedByTitle'
import { push } from 'connected-react-router'

const mapStateToProps = (state, ownProps) => ({
    itemData: getData(state, [PROGRAM_HIGHLIGHTS, ownProps.itemId]),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    features: getData(state, FEATURES),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(highlightsUpdateItem(ownProps.itemId, itemData))
        dispatch(push(ownProps.closePagePath))
    }
})

const EditHighlightContainer = ({itemData, closePagePath, suffixEdit = '', onUpdateItem, movieData, cliCinemas, features, clientCinemaId}) => <EditHighlight
    itemData={itemData}
    closePagePath={closePagePath}
    suffixEdit={suffixEdit}
    onUpdateItem={onUpdateItem}
    features={features}
    movieData={movieData}
    cliCinemas={cliCinemas}
    clientCinemaId={clientCinemaId}
    sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
/>

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditHighlightContainer)